var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"number","name":_vm.name,"id":_vm.id,"size":"1","step":"0.1","autofocus":_vm.autofocus},domProps:{"value":_vm.value},on:{"input":_vm.changeHandler,"click":function (e) { return e.target.select(); }}})}
var staticRenderFns = []

export { render, staticRenderFns }